var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pdl" },
    [
      !_vm.disabled
        ? _c(
            "el-row",
            { staticClass: "mb10", attrs: { type: "flex" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addLine } },
                [_vm._v("添加行")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.clearList } },
                [_vm._v("清空")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-table",
        {
          attrs: {
            border: "",
            "header-cell-class-name": "tableHeader",
            data: _vm.list,
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "核销单品", prop: "auditProductName" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.openModal(scope.row, scope.$index)
                          },
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请选择核销单品",
                            disabled: _vm.disabled,
                            readonly: "",
                          },
                          model: {
                            value: scope.row.auditProductName,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "auditProductName", $$v)
                            },
                            expression: "scope.row.auditProductName",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "单品年销量/万元", prop: "yearSalesNumber" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: { placeholder: "请输入", disabled: _vm.disabled },
                      on: {
                        change: function ($event) {
                          return _vm.toFather()
                        },
                      },
                      model: {
                        value: scope.row.yearSalesNumber,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "yearSalesNumber", $$v)
                        },
                        expression: "scope.row.yearSalesNumber",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          !_vm.disabled
            ? _c("el-table-column", {
                attrs: { label: "操作", width: "80px", fixed: "right" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "delIcon",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteItem(scope.$index)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1318343454
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }